import { render, staticRenderFns } from "./verDate.vue?vue&type=template&id=d33837f8&scoped=true"
import script from "./verDate.vue?vue&type=script&lang=js"
export * from "./verDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33837f8",
  null
  
)

export default component.exports